import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {AuthService} from '../../shared/services/auth/auth.service';
import {AlertService} from '../../shared/services/alert.service';
import {AmplifyService} from 'aws-amplify-angular';
import {NewPasswordModalComponent} from '../modals/new-password-modal/new-password-modal.component';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';
import {BsModalService} from 'ngx-bootstrap/modal';
import {environment} from '../../../environments/environment';
import {UserType} from '../../shared/model/user-type';
import {EndpointType} from "../../shared/model/endpoint-type";
import {MessagingService} from "../../shared/events/messaging-service";
import {CloseAllModalsEvent} from "../../shared/events/close-all-modals-event";
import {DefaultService} from "../../../gen/swagger-api/api/default.service";
import {USERINFO} from "../../../gen/swagger-api";
import {ErrorHandlingService} from '../../shared/services/error-handling-service';

@Component({
  moduleId: module.id,
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.css']
})
export class LoginPageComponent implements OnInit {
  private authKey: string;
  model: any = {};
  loading = false;
  returnUrl: string;
  bsModalRef: BsModalRef;
  user: USERINFO;
  private endpointType: EndpointType;
  private userType: UserType;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthService,
    private alertService: AlertService,
    private amplifyService: AmplifyService,
    private defaultService: DefaultService,
    private modalService: BsModalService,
    private messagingService: MessagingService,
    private errorHandlingService: ErrorHandlingService) {
  }

  ngOnInit() {

    //set authenticationmethod based on url param
    this.endpointType = EndpointType.SERVICEPROVIDER;
    this.userType = UserType.SERVICEPROVIDER_USER;
    // if(this.route.snapshot.params["userType"] === "admin"){
    //   this.endpointType = EndpointType.SERVICEPROVIDER;
    //   this.userType = UserType.SERVICEPROVIDER_USER;
    // } else {
    //   this.endpointType = EndpointType.ENTERPRISE;
    //   this.userType = UserType.ENTERPRISE_USER;
    // }
    sessionStorage.setItem('endpointType', this.endpointType);
    sessionStorage.setItem('userType', this.userType);

    // reset login status
    this.authenticationService.logout();

    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/main';

    //close all modals in case something is open
    this.closeAllModals();
  }

  login() {
    this.loading = true;
    var authMethod;
    if (this.endpointType === EndpointType.ENTERPRISE) {
      authMethod = environment.enterpriseAccountEndpointAuthMethod;
    } else {
      authMethod = environment.serviceProviderEndpointAuthMethod;
    }

    //Autenticate via JWT AUTH
    if (authMethod === 'jwt') {
      this.amplifyService.auth().signIn(this.model.username, this.model.password)
        .then(user => {
          if (user.challengeName === 'NEW_PASSWORD_REQUIRED' || user.challengeName === 'PASSWORD_VERIFIER') {
            //show new password modal
            var initialState = {
              user
            }
            this.bsModalRef = this.modalService.show(NewPasswordModalComponent, {initialState});
          }
          else {
            sessionStorage.setItem('token', user.signInUserSession.accessToken.jwtToken);
            sessionStorage.setItem('username', user.signInUserSession.idToken.payload.name);
            this.authKey = user.signInUserSession.accessToken.jwtToken;
            this.router.navigate([this.returnUrl]);
          }
        })
        .catch(err => {
          this.alertService.error('wrong credentials');
        });
    }

    //Authenticate via BASIC AUTH
    else {
      this.authKey = btoa(`${this.model.username}:${this.model.password}`);
      sessionStorage.setItem('token', this.authKey);

      // if(this.model.username === 'admin' && this.model.password === 'admin'){
      //   // this.user = user;
      //   this.router.navigate([this.returnUrl]);
      //   sessionStorage.setItem('username', 'admin');
      // } else{
      //   this.alertService.error('wrong credentials');
      // }

      this.defaultService.usersUserIdGet(this.model.username).subscribe(
        user => {
          this.user = user;

          if (user)
          {
              var privilegeUserManagement;
              this.getPrivileges().subscribe(permissions => {
                if (permissions !== undefined && permissions !== null && permissions.length) {
                    permissions.forEach( (element) => {
                        if (element.read === true && element.objectId !== 'action') {
                          privilegeUserManagement = element;
                    }
                  });
                  sessionStorage.setItem('privileg-' + this.user.userId, JSON.stringify(privilegeUserManagement));
                } else {
                  sessionStorage.setItem('privileg-' + this.user.userId, JSON.stringify([]));
                }
                this.router.navigate([this.returnUrl]);
              }, error1 => {
                sessionStorage.setItem('privileg-' + this.user.userId, JSON.stringify([]));

                this.router.navigate([this.returnUrl]);
              });

              sessionStorage.setItem('username', user.userId);
          }
          else
          {
              this.alertService.error('Something went wrong during retrieval of user information.');
          }
        },
        error => {
          if (error) {
            this.errorHandlingService.errorHandling(error);
          }
          else {
            this.alertService.error('wrong credentials');
          }
        },
        () => ''
      );
    }
  }

  private getPrivileges() {

    if (this.user)
    {
        return this.defaultService.usersUserIdPermissionsGet(this.user.userId, 'USER_MANAGEMENT');
    }
  }

  private closeAllModals() {
    this.messagingService.publish(new CloseAllModalsEvent());
  }
}



// WEBPACK FOOTER //
// ./src/app/achelos-iot/login-page/login-page.component.ts